import React from 'react';
import Flex from '../../data/Flex';
import UIContainer from '../UIContainer';
import UIFlex from '../UIFlex';
import Overlay from './Overlay';
import './LoadingOverlay.scss';
import { UserView } from '../../view/dashboard/main/UserView';
import './UserOverlay.scss';
import UIButton from "../UIButton";


interface IUserOverlayDetails{
    title?:string;
    desc?:string;
    exitLabel?:string;
}

interface IUserOverlayProps{
    hide:()=>void;
    details:IUserOverlayDetails;
}

export default class UserOverlay extends React.Component<IUserOverlayProps>{
    
    static show=($id:string,$details:IUserOverlayDetails)=>{


        const hideOverlay = Overlay.show($id,{
            className:"userOverlay",
            maxWidth:1250,
            noPadding:true,
            content:(
                <UserOverlay 
                    details={$details}                    
                    hide={()=>{
                        hideOverlay();
                    }}
                />
            ),
        });
        return hideOverlay;
    }
    
    static hide=($id:string)=>{
        Overlay.hide($id);
    }

    _exit=()=>{
        this.props.hide();
    }

    render(){
        let title:string = this.props.details.title || "User Management";

        return (
            <UIFlex flex={{direction:Flex.COLUMN,overflowHidden:true}}>
                <UIFlex className='userHeader' flex={{justifyContent:Flex.CENTER,alignItems:Flex.CENTER,overflowHidden:true}} >
                    {title}
                </UIFlex>
                <UIFlex flex={{justifyContent:Flex.CENTER,alignItems:Flex.CENTER}}>
                  <UserView visible={true}/>
                </UIFlex>
                <UIContainer flex={{alignItems:Flex.FLEX_END, justifyContent:Flex.FLEX_END}} padding>
                  <UIFlex >
                     <UIButton label={"Exit"} onClick={this._exit}/>
                  </UIFlex>
                </UIContainer>
            </UIFlex>
        );
    }
}

